import React, { Component } from 'react';
import Sound from '../UI/Sound';
import { isEmpty } from '@lsgo/lsgo-common/utils';
import { pickRandom } from '@lsgo/lsgo-common';

import withActivityAnalytics from '../../hoc/WithActivityAnalytics';
import { TYPES } from '../../constants/activityTypes';

import SA from 'assets/images/a_doe_tmp/5.png';
import A from 'assets/images/a_doe_tmp/4.png';
import N from 'assets/images/a_doe_tmp/3.png';
import D from 'assets/images/a_doe_tmp/2.png';
import SD from 'assets/images/a_doe_tmp/1.png';

const images = [SD, D, N, A, SA];

class QuizLikert extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentAnswer: null,
            celebrationImage: null,
            showResults: false,
            skip: false,
            tries: 0,
            submitClicked: false,
            isSubmitting: false,
        };

        const { demoMode } = this.props;

        this.handleAnswerClick = this.handleAnswerClick.bind(this);
    }

    handleAnswerClick(choice) {
        //set toggle behavior
        const { currentAnswer } = this.state;

        const stateObject = {
            tries: this.state.tries + 1,
        };

        if (currentAnswer !== choice.id) {
            Object.assign(stateObject, {
                currentAnswer: choice.id,
            });
        }

        this.setState(stateObject);
    }

    handleSubmit = () => {
        const { tries, submitClicked } = this.state;
        let timeout = 5000;

        //check if the student tried at least once
        if (tries === 0) {
            this.props.dispatchAddAlert('Have a try');

            if (!submitClicked) {
                this.setState({
                    submitClicked: true,
                });
            }
            // this.setState({
            //    tries: this.state.tries + 1
            // });
            return false;
        }

        //01. show results,
        this.setState({
            showResults: true,
            isSubmitting: true,
        });

        //02.check if the answer is correct

        const endTime = this.props.endTime();
        const { startTime, activityId } = this.props;

        const resultObj = {
            answer: this.state.currentAnswer,
        };

        this.props.pushActivityAnalytics(startTime, endTime, TYPES.QUIZ_MULTI_SINGLE.ID, activityId, resultObj);

        setTimeout(() => {
            this.props.activityDone();
            this.setState({
                isSubmitting: false,
            });
        }, timeout);
    };

    renderChoices() {
        const { choices } = this.props;

        const { currentAnswer } = this.state;

        return choices.map((choice, i) => {
            const style = {};
            choice.image = images[i];

            // if (choice.image) {
            //     Object.assign(style, {
            //         backgroundImage: `url(${choice.image})`,
            //     });
            // }

            if (choice.color) {
                Object.assign(style, {
                    backgroundColor: choice.color,
                });
            }

            const choiceClass = [];

            if (currentAnswer === choice.id) {
                choiceClass.push('shadow-dr');
            }

            return (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        margin: '0.75rem',
                        cursor: 'pointer',
                        padding: 16,
                    }}
                    onClick={this.handleAnswerClick.bind(this, choice)}
                    className={`${choiceClass.join(' ')}`}
                >
                    {choice.image && (
                        <img src={choice.image} style={{ width: '100%', alignSelf: 'center', maxWidth: 200 }} />
                    )}
                    <div style={{ display: 'flex', alignSelf: 'center' }}>
                        <input
                            type='radio'
                            value={choice.id}
                            checked={currentAnswer === choice.id}
                            name={choice.title}
                        />
                        <div style={{ marginLeft: 16 }}>{choice.title}</div>
                    </div>
                </div>
            );
        });
    }

    render() {
        const { question, questionImage, questionSound, demoMode } = this.props;
        const { celebrationImage, submitClicked, isSubmitting } = this.state;

        const choices = this.renderChoices();

        return (
            <div className='quiz-wrapper'>
                <div className='quiz-content'>
                    <div className='quiz-question'>
                        <h3>{question}</h3>
                        {questionSound && <Sound audioUrl={questionSound} />}
                        {questionImage && (
                            <div className='quiz-question-img'>
                                <img alt={question} src={questionImage} />
                            </div>
                        )}
                    </div>
                    <div className='quiz-answers'>{choices}</div>

                    <div className='clearfix'></div>
                </div>

                {!demoMode && (
                    <div
                        style={{
                            marginBottom: 10,
                            marginTop: 15,
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                    >
                        {isSubmitting && (
                            <div className='lds-ellipsis'>
                                <div />
                                <div />
                                <div />
                                <div />
                            </div>
                        )}
                        <button
                            onClick={this.handleSubmit.bind(this)}
                            className='student-submit-btn'
                            disabled={isSubmitting || (submitClicked && this.state.currentAnswer === null)}
                        >
                            SUBMIT
                        </button>
                    </div>
                )}
                {celebrationImage && (
                    <div className='celebrationImage'>
                        <img alt='' style={{ marginTop: 100 }} width={300} height={300} src={celebrationImage} />
                    </div>
                )}
            </div>
        );
    }
}

export default withActivityAnalytics(QuizLikert);
